import axiosInstance from "./axios-service/axiosInstance";

const headers = {
  Accept: "application/json;odata=nometadata",
};

const referenceService = {
  fetchReferenceByCandidateID: (id) => {
    return axiosInstance.get(
      `/itl_references?$select=itl_address,itl_contact,itl_email,itl_name,itl_reference,itl_relationship&$filter=_itl_candidateid_value eq ${id}`,
      {
        headers: headers,
      }
    );
  },

  addReference: (obj) => {
    return axiosInstance.post(`/itl_references`, obj, {
      headers: headers,
    });
  },

  updateReference: (id, obj) => {
    return axiosInstance.patch(`/itl_references(${id})`, obj, {
      headers: headers,
    });
  },

  deleteReference: (id) => {
    return axiosInstance.delete(`/itl_references(${id})`, {
      headers: headers,
    });
  },
};

export default referenceService;
